import { onMount } from "solid-js";
import { logPageLoad } from "../../../../../utils/logging";

export default function Scatter() {
  onMount(() => {
    void logPageLoad("Scatter.tsx", "Scatter Plot Report", "Loaded");
  });
  return (
    <div class="scatter">
      <p>Historical scatter data goes here</p>
    </div>
  );
}
